import styled from "styled-components";

const SIZES = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 56,
  xl: 80,
};

export const AvatarWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${({ $bg }) => $bg};
  color: #fff;
  font-weight: 600;
  font-size: ${({ $size }) => Math.max(10, Math.round((SIZES[$size] || SIZES.md) * 0.4))}px;
  width: ${({ $size }) => SIZES[$size] || SIZES.md}px;
  height: ${({ $size }) => SIZES[$size] || SIZES.md}px;
  flex-shrink: 0;
  overflow: hidden;
  user-select: none;
  border: 1px solid ${({ theme }) => theme.border};
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
